export const TYPE_RETIREMENT = {
	pharmacy: 'farmacia',
	home: 'domicilio',
};
